// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

const loadImage = (src, _ref) => {
  let {
    onSuccess,
    onFailure
  } = _ref;
  const image = new Image();
  image.onload = onSuccess;
  image.onerror = onFailure;
  image.src = src;
};
export { loadImage };